/**
 * @generated SignedSource<<d0840a26f8f9d056c86ac111569b38c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AuctionLotStatus = "DRAFT" | "OPEN" | "PAUSED" | "CLOSED" | "CANCELED" | "DELETED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly lastTransaction?: {
    readonly checkoutDate: string | null;
    readonly isCanceled: boolean | null;
    readonly mostRecentOffer: {
      readonly isExpired: boolean | null;
    } | null;
  } | null;
  readonly relevantAuctionLot?: {
    readonly status: AuctionLotStatus | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBlurbLeadTime_item" | "PdpRespSidebarBlurbShipping_item" | "PdpSharedBlurbDesignYourOwn_item">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_item";
};
export type PdpRespSidebarBlurbs_item$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchAuction"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            }
          ],
          "concreteType": "Transaction",
          "kind": "LinkedField",
          "name": "lastTransaction",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "checkoutDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isCanceled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Offer",
              "kind": "LinkedField",
              "name": "mostRecentOffer",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isExpired",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "fetchAuction",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "page",
              "value": "pdp"
            }
          ],
          "concreteType": "AuctionLot",
          "kind": "LinkedField",
          "name": "relevantAuctionLot",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": "relevantAuctionLot(page:\"pdp\")"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbLeadTime_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbDesignYourOwn_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "eeb7adcfb8739860915bf5191cf8c4c1";

export default node;
